export const CheckEmptyString = (str: string): boolean => {
    const result = str.replace(/\s/g, '');
    return result === '' ? true : false;
}